<template>
    <div class="form-group" :class="{scroll}">
        <label v-if="hasLabel" :class="labelClasses">
            {{ label }}
        </label>

        <el-select
            :popper-append-to-body="!scroll"
            :class="'select-' + color"
            size="large"
            :placeholder="placeholder"
            filterable
            remote
            :remote-method="search"
            clearable
            :disabled="disabled"
            v-model="localValue"
        >
            <el-option v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    export default {

        props: {
            value: {
                type: Number,
                default: null
            },

            color: {
                type: String,
                default: 'primary'
            },

            label: {
                type: String,
                default: null
            },

            placeholder: {
                type: String,
                default: null
            },

            disabled: {
                type: Boolean,
                default: false
            },

            scroll: {
                type: Boolean,
                default: false
            },

            labelClasses: {
                type: String,
                default: ""
            },

            findMethod: {
                type: Function,
                required: true
            },

            searchMethod: {
                type: Function,
                required: true
            },
        },

        data() {
            return {
                localValue: null,
                options: [],
            }
        },

        computed: {

            hasLabel() {
                return this.label !== null
            },
        },

        created() {
            this.localValue = this.value
        },

        watch: {

            value(newVal) {
                this.localValue = newVal
                if (newVal && !this.options.find(option => option.id == newVal)) {
                    // The assigned value does not exist in the options. Load it.
                    this.find(newVal)
                }
            },
            
            localValue(newVal) {
                this.$emit('input', newVal)
            },
        },

        methods: {

            search(searchString) {
                if (searchString !== '') {
                    this.searchMethod(searchString)
                    .then(resp => {
                        this.options = resp.data.data
                    })
                    .catch(err => {
                        this.options = []
                    })

                } else {
                    this.options = []
                }
            },

            find(itemId) {
                this.findMethod(itemId)
                .then(resp => {
                    this.options = [resp.data.data]
                })
                .catch(err => {
                    this.options = []
                })
            },
        }
    }
</script>

<style scoped>

    .form-group label {
        color: #525f7f;
        font-size: 0.875rem;
        font-weight: 600;
    }
    .form-group >>> .el-select.select-info .el-select__tags .el-tag {
        background: #5e72e4;
    }
    .form-group.scroll >>> .el-select-dropdown__wrap {
        max-height: 274px !important;
    }

</style>
